import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c3-three-three-one-one',
  templateUrl: './c3-three-three-one-one.component.html',
  styleUrls: ['./c3-three-three-one-one.component.scss']
})
export class C3ThreeThreeOneOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
